<template>
    <section :id="slice.primary.anchorName || undefined" class="slice slice-features slice-features--default" aria-label="features">
        <div class="slice-content">
            <div v-if="slice.primary.category" class="slice-features--default__category">{{ slice.primary.category }}</div>
            <PrismicRichText v-if="slice.primary.title" :field="slice.primary.title" class="slice-title" />
            <PrismicRichText v-if="slice.primary.description" :field="slice.primary.description" class="slice-description" />

            <div class="slice-features--default__items">
                <div v-for="(item, i) in slice.items" :key="i" class="slice-features--default__item">
                    <PrismicImage :field="item.image" class="slice-features--default__item-image" />
                    <div class="slice-features--default__item-content">
                        <div class="slice-features--default__item-title">{{ item.title }}</div>
                        <PrismicRichText :field="item.text" class="slice-features--default__item-text" />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {getSliceComponentProps, PrismicImage, PrismicRichText} from '@prismicio/vue';
    import type {FeaturesSlice} from '@prismicio-types';

    type FeaturesCentredInZone = Extract<FeaturesSlice, {variation: 'default'}>;
    defineProps(getSliceComponentProps<FeaturesCentredInZone>());
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .slice-features--default {
        .slice-content {
            text-align: left;
        }

        .slice-description {
            max-width: none;
        }

        &__category {
            font-weight: var(--joy-font-weight-bold);
            color: var(--joy-color-secondary-30);
            margin-bottom: var(--joy-core-spacing-2);
        }

        &__items {
            display: grid;
            gap: var(--joy-core-spacing-8) var(--joy-core-spacing-4);
            margin-top: var(--joy-core-spacing-10);
            grid-template-columns: repeat(1, minmax(0, 1fr));

            @include mq.screen_sm(min) {
                grid-template-columns: repeat(2, minmax(0, 1fr));
            }

            @include mq.screen_md(min) {
                grid-template-columns: repeat(3, minmax(0, 1fr));
            }
        }

        &__item {
            display: flex;
            align-items: flex-start;
            gap: var(--joy-core-spacing-4);

            &-image {
                flex: none;
                width: 40px;
            }

            &-title {
                font-weight: var(--joy-font-weight-bold);
                font-size: var(--joy-font-size-primary-600);
            }

            &-text {
                margin-top: var(--joy-core-spacing-3);
            }
        }
    }
</style>
